jQuery('.banner-background').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    fade: true,
    autoplay: true,
    dots: true,
    rows: 0,
    focusOnSelect: true
  }); 